import Cookies from 'js-cookie';

export const getAuthToken = (): string | null => Cookies.get('session') ?? null;
export const getRefreshToken = (): string | null => Cookies.get('refreshToken') ?? null;

// Note: window.location.hostname is getting whole domain name like:
// '1014lasttest.expert.v2.scsandpit.com'

const domain = window.location.hostname;
const subDomain = domain.split('.').length > 1 ? `.${domain.split('.').reverse()[1]}.${domain.split('.').reverse()[0]}` : domain;

export const setAuthToken = (token: string) => {
  Cookies.set('session', token, {
    path: '/',
    domain,
    expires: 7, // 1 week
  });
  Cookies.set('session-ws-expert', token, {
    path: '/',
    domain: subDomain,
    expires: 7, // 1 week
  });
};
export const setRefreshToken = (refreshToken: string) => {
  Cookies.set('refreshToken', refreshToken, {
    path: '/',
    domain,
    expires: 7, // 1 week
  });
  Cookies.set('refreshToken-ws-expert', refreshToken, {
    path: '/',
    domain: subDomain,
    expires: 7, // 1 week
  });
};

export const clearAuthToken = () => {
  Cookies.remove('session', {
    path: '/',
    domain,
  });
  Cookies.remove('refreshToken', {
    path: '/',
    domain,
  });
  Cookies.remove('session-ws-expert', {
    path: '/',
    domain: subDomain,
  });
  Cookies.remove('refreshToken-ws-expert', {
    path: '/',
    domain: subDomain,
  });
};
